import { transition, trigger } from '@angular/animations';
import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { Package, TablePackage } from '../../models/package.model';
import { Product } from '../../models/product.model';
import { NotificationsService } from '../../services/notifications.service';
import { ShoppingCartService } from '../../services/shoppingcart.service';
import { PackageDialogComponent, PackageDialogInputData, PackageDialogReturnData } from './package-dialog/package-dialog.component';

@Component({
  selector: 'app-package-list',
  templateUrl: './package-list.component.html',
  styleUrls: ['./package-list.component.scss'],
  providers: [DatePipe],
  animations: [
    trigger('blockInitialRenderAnimation', [transition(':enter', [])])
  ]
})
export class PackageListComponent implements OnInit, OnDestroy {

  private subscriptions = new Map<string, Subscription>();

  selectedCache = {};

  @Input() product$: Observable<Product>;
  @Input() expanded: boolean;
  @Input() locale: string;
  @Input() currency: string;
  @Input() readOnly: boolean;
  @Input() internalUser: boolean;
  @Input() cart: boolean;

  constructor(
    private notification: NotificationsService,
    private datePipe: DatePipe,
    private shoppingCartService: ShoppingCartService,
    private translate: TranslateService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.locale = this.translate.currentLang;

    // cached selected packages for performance
    const reducer = (list, pack) => { list[pack.id] = true; return list; };
    this.selectedCache = this.shoppingCartService.contents().reduce(reducer, {});
    this.subscriptions.set('shoppingCartItemsChanged',
      this.shoppingCartService.itemsChanged.subscribe(packages => this.selectedCache = packages.reduce(reducer, {}))
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  isSelected(pack: Package): boolean {
    // return pack ? this.shoppingCartService.hasId(pack.id) : false;
    return pack ? this.selectedCache && this.selectedCache[pack.id] : false;
  }

  onSelectedCard(pkg: Package): void {
    if (this.readOnly || !(pkg.statusCode !== 'VESS')) {
      return;
    }
    if (!pkg.arrivalDate) {
      this.notification.send(
        'NOTIFICATIONS.TEXT_PACKAGE_NOT_AVAILABLE', {
        date: this.datePipe.transform(pkg.estimatedArrivalDate, 'shortDate', undefined, this.locale)
      });
      return;
    }

    if (this.cart) {
      this.openDialog(pkg);
    } else {
      this.shoppingCartService.toggle(pkg);
    }
  }

  openDialog(pkg: Package) {
    const dialogRef = this.dialog.open(PackageDialogComponent, {
      panelClass: 'package-dialog',
      data: {
        product$: this.product$,
        package: pkg,
        cart: this.cart,
        internalUser: this.internalUser,
        currency: this.currency,
      } as PackageDialogInputData,
    });

    dialogRef.afterClosed().subscribe((data: PackageDialogReturnData) => {
      if (data.deselect) {
        this.shoppingCartService.remove(data.package);
      }
      this.shoppingCartService.setPriceCert(data.package, data.package.selectedPrice, data.package.selectedCert);
    });
  }

  onDeselect(pkg: TablePackage): void {
    this.shoppingCartService.remove(pkg.payload);
  }

  trackByPackageId(pkg: TablePackage) {
    return pkg.id;
  }
}
